const sortingAndFiltering = {
    filterAndSort:({ list, searchText, searchableKeys, customFilterKeys, comparer }) => {
        if (!list) return [];

        let processedList = list.filter(a =>
            (!customFilterKeys?.length || customFilterKeys.every(({ key, condition }) => condition(a[key]))) &&
            (
                !searchText ||
                searchableKeys?.some(k => (a[k] || '').toLowerCase().includes(searchText.toLowerCase()))
            )
        );

        if (comparer) {
            processedList.sort(comparer);
        }

        return processedList;
    }
}

export default sortingAndFiltering;
